const  TRIP_ADMIN = {
    FETCH_TRIP_ADMIN : "FETCH_TRIP_ADMIN",
    FETCH_DRIVER_SEARCH : "FETCH_DRIVER_SEARCH",
    FETCH_ELIGIBLE_DRIVERS: "FETCH_ELIGIBLE_DRIVERS",
    UPDATE_PROJECT_CODE: "UPDATE_PROJECT_CODE",
    RESET_UPDATE_STATUS_PROJECT_CODE: "RESET_UPDATE_STATUS_PROJECT_CODE"
};

export default TRIP_ADMIN;
  